var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 25,
    viewBox: "0 0 18 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.000488281 3.5C0.000488281 1.84297 1.34343 0.5 3.00043 0.5H10.5003V6.5C10.5003 7.32969 11.1706 8 12.0003 8H18.0001V21.5C18.0001 23.1547 16.6548 24.5 15.0002 24.5H3.00043C1.34343 24.5 0.000488281 23.1547 0.000488281 21.5V3.5ZM12.0003 6.5V0.5L18.0001 6.5H12.0003Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.c2e1370e00c0110d45e7a53dc886a021.svg";
export { ForwardRef as ReactComponent };